<app-drawer
    [drawerId]="drawerId"
    header="Ask BettaAlpha"
    [styleClass]="'!w-full lg:!w-[56rem]'"
    [closable]="true"
    [dismissible]="true"
>
    <div class="flex h-full min-h-0">
        <!-- Sidebar: New chat, Guides, Recent -->
        <div class="hidden md:flex flex-col w-64 shrink-0 border-r border-primaryBorder gap-5 p-4 overflow-y-auto">
            <app-button label="New chat" variant="secondary" [fluid]="true" (onClick)="onNewConversation()" />

            @if (chatService.guidesLoading() || chatService.guides().length > 0) {
            <div class="flex flex-col gap-2">
                <span class="text-caption text-secondaryLabel uppercase tracking-wide">Guides</span>
                @if (chatService.guidesLoading()) {
                <p-skeleton height="1.25rem" width="100%" />
                <p-skeleton height="1.25rem" width="80%" />
                } @else {
                @for (guide of chatService.guides(); track guide.id) {
                <button
                    type="button"
                    (click)="openGuide(guide)"
                    class="flex items-center gap-2 text-body-large text-headingText hover:underline text-left"
                    [title]="guide.title + (guide.sizeBytes ? ' (' + formatFileSize(guide.sizeBytes) + ')' : '')"
                >
                    <i class="pi pi-file text-secondaryText shrink-0"></i>
                    <span class="truncate">{{ guide.title }}</span>
                </button>
                }
                }
            </div>
            }

            <div class="flex flex-col gap-2">
                <span class="text-caption text-secondaryLabel uppercase tracking-wide">Recent</span>
                @if (chatService.conversationsLoading()) {
                <p-skeleton height="1.25rem" width="100%" />
                <p-skeleton height="1.25rem" width="100%" />
                <p-skeleton height="1.25rem" width="70%" />
                } @else if (!chatService.conversations().length) {
                <span class="text-caption text-secondaryLabel">No recent conversations yet.</span>
                } @else {
                @for (conversation of chatService.conversations(); track conversation.id) {
                <button
                    type="button"
                    class="text-left text-body-large truncate py-1"
                    [class.text-primaryText]="conversation.id === activeConversationId()"
                    [class.text-bodyText]="conversation.id !== activeConversationId()"
                    [title]="conversation.title"
                    (click)="onOpenConversation(conversation.id)"
                >
                    {{ conversation.title }}
                </button>
                }
                }
            </div>
        </div>

        <!-- Chat pane -->
        <div class="flex flex-col flex-1 min-w-0 px-5 py-2.5 gap-4">
            <div class="flex items-center justify-between md:hidden">
                <span class="text-caption text-secondaryLabel">Ask about your own deals, or how to use the platform.</span>
                @if (chatService.messages().length > 0) {
                <app-button variant="text" size="small" label="New chat" (onClick)="onNewConversation()" />
                }
            </div>

            <div class="flex flex-col gap-3 flex-1 min-h-[240px] overflow-y-auto">
                @if (chatService.messages().length === 0) {
                <div class="flex flex-col gap-2">
                    @for (question of chatService.suggestedQuestions(); track question) {
                    <app-tag [value]="question" [clickable]="true" (onClick)="onSuggestedQuestionClick(question)" styleClass="!block !text-left w-full whitespace-normal" />
                    }
                </div>
                }

                @for (message of chatService.messages(); track $index) {
                <div class="flex" [class.justify-end]="isFromUser(message.role)" [class.justify-start]="!isFromUser(message.role)">
                    <div
                        class="max-w-[85%] rounded-8 px-3 py-2 flex flex-col gap-1.5"
                        [class.bg-brandAntiqueGoldBackground]="isFromUser(message.role)"
                        [class.bg-surface-100]="!isFromUser(message.role)"
                    >
                        @if (isFromUser(message.role)) {
                        <span class="text-body-large text-headingText whitespace-pre-wrap">{{ message.text }}</span>
                        } @else {
                        <div class="text-body-large text-headingText flex flex-col gap-1.5 [&_p]:m-0" [innerHTML]="formatAssistantMarkdown(message.text)"></div>
                        }
                    </div>
                </div>
                }

                @if (chatService.activeToolCall()) {
                <div class="flex justify-start">
                    <span class="text-caption text-secondaryLabel italic">Checking your data…</span>
                </div>
                }

                @if (chatService.error()) {
                <div class="flex justify-start">
                    <span class="text-caption text-error">{{ chatService.error() }}</span>
                </div>
                }
            </div>

            <div class="rounded-4 bg-surface-50 p-3 flex flex-col gap-3">
                <app-input
                    type="textarea"
                    [fluid]="true"
                    [rows]="2"
                    placeholder="Ask a question…"
                    [value]="draft()"
                    (valueChange)="draft.set($event)"
                    [disabled]="chatService.isStreaming()"
                />
                <div class="flex items-center justify-end">
                    <app-button label="Send" variant="primary" [disabled]="chatService.isStreaming() || !draft().trim()" [loading]="chatService.isStreaming()" (onClick)="onSend()" />
                </div>
            </div>
        </div>
    </div>
</app-drawer>

<app-doc-preview-dialog
    [visible]="previewVisible()"
    (visibleChange)="previewVisible.set($event)"
    [url]="previewUrl"
    [fileName]="previewFileName"
/>
